import React from 'react';
import { Check } from 'lucide-react';

const PUNKTE = ['App holen', 'Verbinden', 'Code'];

// Punkte-Leiste ① App holen – ② Verbinden – ③ Code; bei Schritt 4 alle grün.
export const SchrittLeiste = ({ schritt }) => (
  <div className="flex items-start justify-center" aria-hidden="true" data-testid="zwei-faktor-schrittleiste">
    {PUNKTE.map((name, i) => {
      const nr = i + 1;
      const erledigt = schritt > nr;
      const aktuell = schritt === nr;
      const kreis = erledigt ? 'bg-green-600 text-white' : aktuell ? 'bg-blue-800 text-white' : 'bg-slate-200 text-slate-500';
      return (
        <React.Fragment key={name}>
          {i > 0 && <div className={`mt-4 h-0.5 w-8 sm:w-14 ${schritt >= nr ? 'bg-green-600' : 'bg-slate-200'}`} />}
          <div className="flex w-16 flex-col items-center gap-1" data-testid={`zwei-faktor-punkt-${nr}`} data-zustand={erledigt ? 'erledigt' : aktuell ? 'aktuell' : 'offen'}>
            <div className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold ${kreis}`}>
              {erledigt ? <Check className="h-4 w-4" /> : nr}
            </div>
            <span className="text-center text-xs text-slate-600">{name}</span>
          </div>
        </React.Fragment>
      );
    })}
  </div>
);

export default SchrittLeiste;
